import styled from "styled-components";

export const StyledBackgroundBox = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px;
    border-radius: 10px;
    background-color: ${({ theme, backgroundColor }) => backgroundColor ? backgroundColor : theme.colors.darkSteelBlue};
    ${({ customStyle }) => customStyle && customStyle};
`;